import NetworkManager from './NetworkManager';

export interface ProductSearchResult {
  code: string;
  name: string;
  description?: string;
  label: string;
}

export interface BundleSearchResult {
  code: string;
  name: string;
  label: string;
}

export interface VariantSearchResult {
  code: string;
  name: string;
  label: string;
}

export interface ModifierSearchResult {
  code: string;
  name: string;
  label: string;
}

export interface OptionValueSearchResult {
  code: string;
  name: string;
  label: string;
}

/**
 * Search for products by query string
 */
export async function searchProducts(query: string): Promise<ProductSearchResult[]> {
  if (!query || query.length < 2) {
    return [];
  }

  try {
    const response = await NetworkManager.get<{ status: boolean; data: ProductSearchResult[] }>(
      `/products/search?query=${encodeURIComponent(query)}`
    );
    return response.data || [];
  } catch (error) {
    console.error('Failed to search products:', error);
    // Log more details for debugging
    if (error instanceof Error) {
      console.error('Error details:', {
        message: error.message,
        response: (error as any).response?.data,
        status: (error as any).response?.status
      });
    }
    return [];
  }
}

/**
 * Search for bundles by query string
 */
export async function searchBundles(query: string): Promise<BundleSearchResult[]> {
  if (!query || query.length < 2) {
    return [];
  }

  try {
    const response = await NetworkManager.get<{ status: boolean; data: BundleSearchResult[] }>(
      `/bundles/search?query=${encodeURIComponent(query)}`
    );
    return response.data || [];
  } catch (error) {
    console.error('Failed to search bundles:', error);
    return [];
  }
}

/**
 * Search for variants by query string
 */
export async function searchVariants(query: string): Promise<VariantSearchResult[]> {
  if (!query || query.length < 2) {
    return [];
  }

  try {
    const response = await NetworkManager.get<{ status: boolean; data: VariantSearchResult[] }>(
      `/variants/search?query=${encodeURIComponent(query)}`
    );
    return response.data || [];
  } catch (error) {
    console.error('Failed to search variants:', error);
    return [];
  }
}

/**
 * Search for modifiers by query string
 */
export async function searchModifiers(query: string): Promise<ModifierSearchResult[]> {
  if (!query || query.length < 2) {
    return [];
  }

  try {
    const response = await NetworkManager.get<{ status: boolean; data: ModifierSearchResult[] }>(
      `/modifiers/search?query=${encodeURIComponent(query)}`
    );
    return response.data || [];
  } catch (error) {
    console.error('Failed to search modifiers:', error);
    return [];
  }
}

/**
 * Search for option values by query string
 */
export async function searchOptionValues(query: string): Promise<OptionValueSearchResult[]> {
  if (!query || query.length < 2) {
    return [];
  }

  try {
    const response = await NetworkManager.get<{ status: boolean; data: OptionValueSearchResult[] }>(
      `/option-values/search?query=${encodeURIComponent(query)}`
    );
    return response.data || [];
  } catch (error) {
    console.error('Failed to search option values:', error);
    return [];
  }
}